import { render } from "./AppMenu.vue?vue&type=template&id=43555185"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script